import { gql } from '@apollo/client';

const GET_ACTIVITY = gql`
  query ($where: ReadActivityWhereInput!) {
    findTheObjects(where: $where) {
      id
      title
      book {
        id
        bookCode
        type
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      pages {
        animation {
          src
          vtt
        }
        page {
          id
          pageNumber
        }
        contents {
          description
        }
        svg {
          src
        }
        objects {
          id
          src
          vtt
          description
          animation
          occurrences
          captions
        }
      }
      instructions {
        src
        description
      }
    }
  }
`;
export default GET_ACTIVITY;
